import { IsNotEmpty, IsOptional, IsString } from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class CreateLessonStatusDto {
  @ApiProperty({ type: 'string', description: 'Code du statut de leçon', example: 'SCHEDULED' })
  @IsNotEmpty()
  @IsString()
  code!: string

  @ApiProperty({ type: 'string', description: 'Nom du statut de leçon', example: 'Planifié' })
  @IsNotEmpty()
  @IsString()
  name!: string

  @ApiPropertyOptional({ type: 'string', description: 'Description' })
  @IsOptional()
  @IsString()
  description?: string
}
